import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styles from '../MyGuildView/MyGuildView.module.scss';
import Table from '../HorseView/TableRace/Table';
import { columns, memberGuildSocialIcons, memberSocialIcons, ownerSocialIcons } from '../SocialView/SocialView';
import SocialIcons from '../SocialView/SocialIcons/SocialIcons';
import ProfileDetails from '../MyAccount/ProfileDetails/ProfileDetails';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store/reducers';
import { useNavigate } from 'react-router-dom';
import { activateUser, makeAdmin, revokeAdmin } from '../../store/reducers/Guild/guildRequest';
import AdditionalSelectInput from '../AdditionalSelectInput/AdditiondalSelectInput';
import DeleteUserFromGuildModal from '../../components/Modals/DeleteUserFromGuildModal/DeleteUserFromGuildModal';
import GuildModal from '../../components/Modals/GuildModal/GuildModal';
import DeleteModal from '../../components/Modals/DeleteModal/DeleteModal';
import JoinRequestModal from '../../components/Modals/JoinRequestModal/JoinRequestModal';
import { getRequests } from '../../store/reducers/Guild/race';
import ChatModal, { CHAT_MODAL_VIEWS } from '../../components/Modals/ChatModal/ChatModal';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import { GuildActionsName, MembersType, PrivacyType } from '../../store/reducers/Guild/guildType';
import LabelBox, { displayName } from '../../components/LabelBox/LabelBox';
import { useSelector } from 'react-redux';
import { PROFILE_AVATARS } from '../../components/PhotoSelect/PhotoSelectData';
import { pickUserAvatar } from '../../components/PhotoSelect/PhotoSelect';
export var DropdownOptionsType;
(function (DropdownOptionsType) {
    DropdownOptionsType["REVOKE_ADMIN"] = "revoke-admin";
    DropdownOptionsType["MAKE_ADMIN"] = "make-admin";
    DropdownOptionsType["BAN_USER"] = "ban-user";
    DropdownOptionsType["ACTIVATE_USER"] = "activate-user";
})(DropdownOptionsType || (DropdownOptionsType = {}));
const AdminGuild = ({ membersList, id }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const guildInfo = useSelector((state) => state.guild.guildInfo);
    const requests = useSelector((state) => state.race.requests);
    const [member, setMember] = useState();
    const [guildId, setGuildId] = useState('');
    const [banUserModal, setBanUserModal] = useState(false);
    const [makeAdminModal, setMakeAdminModal] = useState(false);
    const [revokeAdminModal, setRevokeAdminModal] = useState(false);
    const [requestGuildModal, setRequestGuildModal] = useState(false);
    const [activateUserModal, setActivateUserModal] = useState(false);
    const [userData, setUserData] = useState(null);
    const [deleteUserFromGuild, setDeleteUserFromGuild] = useState(false);
    const [messagesModal, setMessagesModal] = useState(false);
    const address = useSelector((state) => state.wallet.activeWallet.address);
    const revokeAdminOption = [
        { value: DropdownOptionsType.REVOKE_ADMIN, label: t('revoke_admin') }
    ];
    const activateAdminOption = [
        { value: DropdownOptionsType.ACTIVATE_USER, label: t('activate_user') }
    ];
    const adminDropdownOptions = [
        { value: DropdownOptionsType.MAKE_ADMIN, label: t('make_admin') },
        { value: DropdownOptionsType.BAN_USER, label: t('ban_user') }
    ];
    const isOwnerOrAdmin = (guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.type) === MembersType.ADMIN || (guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.type) === MembersType.OWNER;
    const isOwner = (guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.type) === MembersType.OWNER;
    const isAdmin = (guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.type) === MembersType.ADMIN;
    const handleDropdownOptions = (e, member) => {
        setUserData(member);
        if (id)
            setGuildId(id);
        const sendAdminActions = {
            [DropdownOptionsType.MAKE_ADMIN]: () => setMakeAdminModal(true),
            [DropdownOptionsType.REVOKE_ADMIN]: () => setRevokeAdminModal(true),
            [DropdownOptionsType.BAN_USER]: () => setBanUserModal(true),
            [DropdownOptionsType.ACTIVATE_USER]: () => setActivateUserModal(true)
        };
        sendAdminActions[e]();
    };
    const iconsAction = {
        cancel: (member) => {
            setDeleteUserFromGuild(true);
            setMember(member);
        },
        messages: (member) => {
            setMember(member);
            setMessagesModal(true);
        },
        cup: () => { },
        diamond: () => { },
        basket: () => { }
    };
    const handleIconClick = (name, member) => {
        iconsAction[name](member);
    };
    const displayCorrectText = () => {
        const isGuildPrivate = (guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.privacy) === PrivacyType.PRIVATE;
        return isOwnerOrAdmin && isGuildPrivate
            ? `${t('join_requests')} (${(requests === null || requests === void 0 ? void 0 : requests.length) || 0})`
            : '';
    };
    const displayCorrectOptionData = (member) => {
        const isMemberTypeMember = member.type === MembersType.MEMBER;
        const isMemberTypeAdmin = member.type === MembersType.ADMIN;
        if (isOwner && isMemberTypeAdmin) {
            return revokeAdminOption;
        }
        else if (isOwnerOrAdmin && isMemberTypeMember && member.member.guildBan) {
            return activateAdminOption;
        }
        else if (isOwnerOrAdmin && isMemberTypeMember) {
            return adminDropdownOptions;
        }
    };
    const displayIcons = (member) => {
        if (member.member.address === address) {
            return memberGuildSocialIcons;
        }
        else if (isOwner || (isAdmin && member.type === MembersType.MEMBER)) {
            return ownerSocialIcons;
        }
        else {
            return memberSocialIcons;
        }
    };
    const makeMemberImage = (member) => {
        if (member.photo) {
            const path = pickUserAvatar(PROFILE_AVATARS[0].contents, member.photo);
            if (member.photo === 'logo') {
                return (_jsx("div", Object.assign({ onClick: () => navigate(`/stables/${member.address}/race`), className: "avatar" }, { children: _jsx(Logo, {}) })));
            }
            return (_jsx("div", Object.assign({ onClick: () => navigate(`/stables/${member.address}/race`), className: "avatar" }, { children: _jsx("img", { src: path, alt: "Avatar" }) })));
        }
        else {
            return (_jsx("div", Object.assign({ onClick: () => navigate(`/stables/${member.address}/race`), className: "avatar" }, { children: _jsx(Logo, {}) })));
        }
    };
    const membersListData = membersList === null || membersList === void 0 ? void 0 : membersList.map((member) => (Object.assign(Object.assign({}, member), { avatar: makeMemberImage(member.member), name: (_jsx(LabelBox, { onClick: () => navigate(`/stables/${member.member.address}/race`), member: member })), status: (_jsx(AdditionalSelectInput, { options: displayCorrectOptionData(member) || null, onChange: (e) => handleDropdownOptions(e.value, member) })), icons: (_jsx(SocialIcons, { onClick: (name) => handleIconClick(name, member), icons: displayIcons(member) })) })));
    useEffect(() => {
        if (id && isOwnerOrAdmin && guildInfo.privacy !== PrivacyType.OPEN) {
            dispatch(getRequests(id));
        }
    }, [isOwnerOrAdmin, guildInfo, dispatch, id]);
    const memberId = useMemo(() => {
        var _a;
        return (_a = member === null || member === void 0 ? void 0 : member.member) === null || _a === void 0 ? void 0 : _a.id;
    }, [member]);
    return (_jsxs(_Fragment, { children: [_jsx(ProfileDetails, Object.assign({ onClick: () => setRequestGuildModal(true), text: displayCorrectText(), className: styles.tableBox, title: `${t('members')} (${membersList === null || membersList === void 0 ? void 0 : membersList.length})` }, { children: _jsx(Table, { columns: columns.filter((el) => el.accessor !== 'guild_name'), className: styles.table, tableData: membersListData || [], onClick: (data) => navigate(`/stables/${data.member.address}/race`) }) })), deleteUserFromGuild && member && (_jsx(DeleteUserFromGuildModal, { guildId: guildInfo.id, userId: member.member.id, userName: displayName(member.member.name, member.member.address || ''), closeModal: () => setDeleteUserFromGuild(false) })), banUserModal && (_jsx(GuildModal, { closeModal: () => setBanUserModal(false), userData: userData, guildId: guildId, title: `Ban ${displayName((userData === null || userData === void 0 ? void 0 : userData.member.name) || '', (userData === null || userData === void 0 ? void 0 : userData.member.address) || '')}` })), activateUserModal && (_jsx(DeleteModal, { label: GuildActionsName.ACTIVATE_USER, closeModal: () => setActivateUserModal(false), onClick: () => {
                    dispatch(activateUser({ guildId: id, data: { id: userData === null || userData === void 0 ? void 0 : userData.member.id } }));
                }, title: `Activate User of ${displayName((userData === null || userData === void 0 ? void 0 : userData.member.name) || '', (userData === null || userData === void 0 ? void 0 : userData.member.address) || '')}`, buttonName: t('activate_user') })), makeAdminModal && (_jsx(DeleteModal, { label: GuildActionsName.MAKE_ADMIN, closeModal: () => setMakeAdminModal(false), onClick: () => {
                    dispatch(makeAdmin({ guildId: id, userId: userData === null || userData === void 0 ? void 0 : userData.member.id }));
                }, title: `Make admin of ${displayName((userData === null || userData === void 0 ? void 0 : userData.member.name) || '', (userData === null || userData === void 0 ? void 0 : userData.member.address) || '')}`, buttonName: t('make_admin') })), revokeAdminModal && (_jsx(DeleteModal, { label: GuildActionsName.REVOKE_ADMIN, closeModal: () => setRevokeAdminModal(false), onClick: () => {
                    dispatch(revokeAdmin({ guildId: id, userId: userData === null || userData === void 0 ? void 0 : userData.member.id }));
                }, title: `Revoke admin of ${displayName((userData === null || userData === void 0 ? void 0 : userData.member.name) || '', (userData === null || userData === void 0 ? void 0 : userData.member.address) || '')}`, buttonName: t('revoke_admin') })), requestGuildModal && (_jsx(JoinRequestModal, { guildInfo: guildInfo, requests: requests || [], closeModal: () => setRequestGuildModal(false) })), messagesModal && (_jsx(ChatModal, { singleChat: true, guildChat: false, memberId: memberId, chatViews: CHAT_MODAL_VIEWS.CHAT_VIEW, closeModal: () => setMessagesModal(false) }))] }));
};
export default AdminGuild;
